import React from 'react';
import { classNames } from '~/utils/classNames';

interface AttachmentPreviewProps {
  name: string;
  attachmentName: string;
  icon: React.ReactNode;
  onRemove: () => void;
  loading?: boolean;
  onClickAttachmentName?: () => void;
}

export const AttachmentPreview: React.FC<AttachmentPreviewProps> = ({
  name,
  attachmentName,
  icon,
  onRemove,
  loading = false,
  onClickAttachmentName,
}) => {
  return (
    <div
      className={classNames(
        'relative inline-flex items-center gap-3 pl-3 pr-10 py-3 rounded-xl min-w-[180px]',
        'bg-dualite-background-button',
      )}
    >
      <div
        className={classNames(
          'relative flex items-center justify-center w-10 h-10 rounded-lg',
          'bg-dualite-background-button',
        )}
      >
        {icon}
        {loading && (
          <div className="absolute inset-0 bg-dualite-background-button flex items-center justify-center rounded-lg pointer-events-none">
            <div className="i-ph:spinner-gap-light text-xl text-dualite-text-secondary animate-spin" />
          </div>
        )}
      </div>

      <div className="flex flex-col min-w-0">
        <span className="text-sm font-medium text-dualite-text-secondary truncate">{name}</span>
        {onClickAttachmentName ? (
          <span
            className="text-xs mt-2 transition-colors text-dualite-text-secondary cursor-pointer hover:text-dualite-text-primary"
            onClick={onClickAttachmentName}
          >
            {attachmentName}
          </span>
        ) : (
          <span className="text-xs text-dualite-text-tertiary mt-2">{attachmentName}</span>
        )}
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        className={classNames(
          'absolute top-2 right-2',
          'flex items-center justify-center w-5 h-5 rounded-full',
          'bg-dualite-background-button hover:bg-dualite-background-buttonHover',
          'transition-colors duration-150',
        )}
        aria-label="Detach Asset from Chat"
      >
        <div className="i-ph:x text-xs text-dualite-text-secondary hover:text-dualite-text-primary" />
      </button>
    </div>
  );
};
